import { createContext, useContext } from 'react'

import { API } from './API'

export const APIContext = createContext<API | undefined>(undefined)

export function useApi() {
  const api = useContext(APIContext)

  if (!api) {
    throw new Error('Must use useApi within an APIContext')
  }

  return api
}
